import { render, staticRenderFns } from "./PopupSignField.vue?vue&type=template&id=128f1866&scoped=true"
import script from "./PopupSignField.vue?vue&type=script&lang=js"
export * from "./PopupSignField.vue?vue&type=script&lang=js"
import style0 from "./PopupSignField.vue?vue&type=style&index=0&id=128f1866&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f1866",
  null
  
)

export default component.exports